import { AgentType } from '@server/ai';
import { PlanFeature } from '@server/plan';
import { AccountType } from '@server/account-type';
import { useSelector } from 'react-redux';
import { selectPlanFeatures, selectUserInfoData } from '../../reducers/userInfoReducer';
import { useMemo } from 'react';

const useAgentsSubscriptions: () => Record<AgentType, boolean> = () => {
  const planFeatures = useSelector(selectPlanFeatures);
  const userInfo = useSelector(selectUserInfoData);

  return useMemo(() => {
    if (userInfo?.account?.type === AccountType.Internal || userInfo?.email?.endsWith('@sweep.io')) {
      return {
        [AgentType.Documentation]: true,
        [AgentType.ProcessOptimization]: true,
        [AgentType.Monitoring]: false, // Always disabled - legacy agent,
        [AgentType.MonitoringV2]: true,
        [AgentType.Permissions]: true,
        [AgentType.Support]: true,
      };
    }

    return {
      [AgentType.Documentation]: !!planFeatures?.includes(PlanFeature.DocumentationAgent),
      [AgentType.ProcessOptimization]: !!planFeatures?.includes(PlanFeature.ProcessOptimizationAgent,),
      [AgentType.Monitoring]: false, // Always disabled - legacy agent
      [AgentType.MonitoringV2]: !!planFeatures?.includes(PlanFeature.MonitoringAgent),
      [AgentType.Permissions]: !!planFeatures?.includes(PlanFeature.PermissionsAgent),
      [AgentType.Support]: true, // TODO gate behind plan feature when available
    };
  }, [planFeatures, userInfo?.account?.type, userInfo?.email]);
};

export default useAgentsSubscriptions;
